import { Confirm } from '../../components';
import { t, PHRASES } from '../../translate';
export function noMoneyAlert(props) {
    var alert = new Confirm({
        className: 'RwConfirm',
        message: function () { return t(PHRASES.You_need_replenish_balance); },
        okBtnText: function () { return t(PHRASES.Ok); },
        cancelBtnVisible: false,
        closeBtnVisible: true,
        onClick: function (ok) {
            if (ok) {
                props.storeModal().show();
            }
            alert.hide();
        },
    });
    if (DEVELOPMENT && location.search.includes('showRVConfirm')) {
        alert.show();
    }
    return alert;
}
